export default {"src":"/_next/static/media/lobby-background.7905ba1a.svg","height":544,"width":1120,"blurWidth":0,"blurHeight":0};